import { render, staticRenderFns } from "./Table12.vue?vue&type=template&id=29d70f2a&scoped=true&"
import script from "./Table12.vue?vue&type=script&lang=js&"
export * from "./Table12.vue?vue&type=script&lang=js&"
import style0 from "./Table12.vue?vue&type=style&index=0&id=29d70f2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d70f2a",
  null
  
)

export default component.exports